import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";

Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    bus: new Vue(),
    user: null,
    company: null,
    crew: null,
    companies: [],
    crews: [],
    employee: null,
    language: "en",
    date: moment().format("YYYY-MM-DD")
  },
  getters: {},
  methods: {},
  actions: {},
  mutations: {
    load(state, stored) {
      state.user = stored.user;
      state.companies = stored.companies;
      state.company = stored.company;
      state.crew = stored.crew;
    },
    login(state, user) {
      state.date = moment().format("YYYY-MM-DD");
      if (!user) {
        state.user = null;
        state.companies = [];
        state.company = null;
        state.crew = null;
        state.employee = null;
        return;
      }
      state.user = user;
      state.companies = user.companies.filter(c => c.crews && c.crews.length > 0);

      if (state.companies.length > 0) {
        state.company = state.companies[0];
      } else {
        return;
      }

      state.crews = state.company.crews;
      if (state.company.crews.length > 0) {
        state.crew = state.company.crews[0];
        state.bus.$emit("crew");
      } else {
        return;
      }
      state.employee = null;
    },
    company(state, company) {
      state.company = company;
      if (state.company.crews.length > 0) {
        state.crew = state.company.crews[0];
      } else {
        return;
      }
      state.employee = null;
      state.crews = state.company.crews;
      if (state.company.crews.length > 0) {
        state.crew = state.company.crews[0];
        state.bus.$emit("crew");
      } else {
        return;
      }
    },
    crew(state, crew) {
      state.crew = crew;
      state.employee = null;
      state.bus.$emit("crew");
    },
    employee(state, employee) {
      state.employee = employee;
      state.bus.$emit("employee");
    },
    date(state, date) {
      state.date = date;
      state.bus.$emit("date");
    }
  },
  modules: {}
});